module.exports = __webpack_public_path__ + "img/Alipay.9596da2a.png";